import loadReduxAction from 'modules/redux/actions/load'
import {
  PLANS_ACTION,
  PLANS_DOMAIN,
  PLANS_ENDPOINT,
  PLANS_PATH
} from 'modules/plan/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import { TRAINING_PLAN_CLASS_NAME } from 'modules/training/models/plan/constants'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { logUtil } from 'packages/src'
import { getByIdTrainingPlanSelector } from 'modules/plan/redux/selectors/index.js'
import { updateCurrentPlanAction } from '@gymaholic/packages'

/**
 * @param id
 * @param match
 * @param options
 * @param queryParams
 * @returns {(function(*, *): Promise<void>)|*}
 */
function loadByRecommendedIdPlanAction ({
  id,
  match,
  options,
  queryParams
}) {
  return async (dispatch, getState) => {
    id = (id || match?.params?.id)
    const logPrefix = `id=${id}`
    const debugProps = {
      options,
      queryParams
    }
    logUtil('loadByRecommendedIdPlanAction').debug(`${logPrefix} [start] debugProps=`, debugProps)

    if (!id) {
      logUtil('loadByRecommendedIdPlanAction').warn(`${logPrefix} [noop] no id`)
      return
    }

    const endpoint = getEndpointTrainingUtil(
      interpolateRouteUtil(PLANS_ENDPOINT.LOAD_RECOMMENDED_BY_ID, { id }),
      queryParams
    )

    const data = {
      id,
      className: TRAINING_PLAN_CLASS_NAME
    }

    try {
      await dispatch(
        loadReduxAction({
          type: PLANS_ACTION.LOAD_RECOMMENDED_BY_ID,
          payload: {
            endpoint,
            domainListPath: PLANS_PATH.ALL,
            path: getPathFromDomainPathReduxUtil(PLANS_DOMAIN, id),
            data
          },
          options
        })
      )

      const plan = getByIdTrainingPlanSelector(id)(getState())
      dispatch(updateCurrentPlanAction(plan))
      logUtil('loadByRecommendedIdPlanAction').debug(`${logPrefix} [done]`)
    } catch (error) {
      logUtil('loadByRecommendedIdPlanAction').error(`${logPrefix} error=`, error)
    }
  }
}

export default loadByRecommendedIdPlanAction
